module.exports = __webpack_public_path__ + "media/images/brand/pixiv-9ef76fffc26e23606731bc747c8487c2.svg";